<div class="card card-default mt-3">
    <div class="card-header">
        <span class="text-table-title">
            {{ titleCard }}
        </span>
        <div class="card-body p-0 mt-3">
            <ng-content></ng-content>
        </div>
    </div>
</div>